/**
 * OrbDocCoreConceptsClosedCircuitSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsClosedCircuitSLDocScreen
 */

import { useOrbDocCoreConceptsClosedCircuitSLDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsClosedCircuitSLDocScreenLogic';
import type { OrbDocCoreConceptsClosedCircuitSLDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsClosedCircuitSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsClosedCircuitSLDocView as OrbDocCoreConceptsClosedCircuitSLDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsClosedCircuitSLDocBodyView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitSLDocBodyView';
import { OrbDocCoreConceptsClosedCircuitSLDocFooterView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitSLDocFooterView';
import { OrbDocCoreConceptsClosedCircuitSLDocHeaderView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsClosedCircuitSLDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsClosedCircuitSLDocScreenConfig>;
}

export function OrbDocCoreConceptsClosedCircuitSLDocScreenView({ config: propsConfig }: OrbDocCoreConceptsClosedCircuitSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsClosedCircuitSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsClosedCircuitSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsClosedCircuitSL" trait="OrbDocCoreConceptsClosedCircuitSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsClosedCircuitSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsClosedCircuitSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsClosedCircuitSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsClosedCircuitSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsClosedCircuitSLDocScreenView;
